const domainURL = window.location.origin;
const domainURLHostName = window.location.hostname;
export const API_PRODUCT_AND_STORE = domainURL+"/files/"+domainURLHostName+"/"+domainURLHostName+"-config.json?"+Math.random();
export const API_BUILDER_CHECKOUT_SAVE = domainURL+"/iar/checkout/placeOrder";
export const API_CHECKOUT_SAVE = domainURL+"/iar/sendMailSms";
export const STORE_URL = domainURL+"/";
